(function($, window, undefined) {

  /* Next button */
  $('#UploadImages').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('.product-info').addClass('hidden');
    $('#UploadImages').addClass('hidden');
    $('.product-upload-images').removeClass('hidden');
    if (window.getQueryParam('updatecart') == 1) {
      $('#UpdateCartItem').removeClass('hidden');
    } else {
      $('#AddToCart').removeClass('hidden');
    }

    // Show the uploader larger for certain product types
    if (window.productType == "Guest Books" || window.productType == "Journals") {
      $('.product-single__hero .grid__item').removeClass('post-large--one-half');
      $('.product-single__hero .grid__item').eq(1).addClass('text-center');
      $('.product-single__hero .grid__item').eq(1).find('.selector-wrapper select').css('margin', '0 auto 1em');
      $(window).scrollTop(0);
    }
  });

  var reversed;

  function processOrientationLogic(){
    var $this = $(this);

    if (($this.val() == 'Landscape' && !reversed) || ($this.val() == 'Portrait' && reversed)) {
    	$('.product-image').addClass('landscape');
    } else {
   		$('.product-image').removeClass('landscape');
    }

    // Update image scale
    ['front', 'back'].forEach(function(side){
    	var url = $('#product-image-' + side).val();
      if (!url) {
      	return;
      }

      var $productImageContainer = $('.product-image.' + side);
      var $image = $productImageContainer.children('div.image');
      window.fspUtils.setImage(
        $image,
        window.fspUtils.cacheAndConvertFileStackUrlToJpg(url),
        $productImageContainer.hasClass('landscape')
      );
    });
  }

  /* Portrait/Landscape toggle on load */
  $(document).ready(function() {

    reversed = (window.productOrientationReverse !== undefined && window.productOrientationReverse === 'y');

    if (reversed){
      processOrientationLogic.call($('.product-customizer-option[data-option-name="orientation"] select').get(0));
    }
  });

  /* Portrait/Landscape toggle */
  $('.product-customizer-option[data-option-name="orientation"]').find('select').on('change keyup keydown mouseup', processOrientationLogic);

  /* Show/Hide instructions button */
  $('button.show-hide-instructions').on('click', function(event) {
    var $button = $(this);
    var $parent = $button.closest('.product-image-instruction');
    var side = $parent.hasClass('back') ? 'back' : 'front';
    var $productImageContainer = $parent.siblings('.product-image.' + side);
    $productImageContainer.children('img.instructions').toggleClass('hidden');
  });

  /* Upload artwork button */
  $('button.upload-artwork').on('click', function(event) {
    if (!window.customerId) {
      //$('#login-modal').addClass('visible');
      $('#login-modal').trigger('show');
      return;
    }
    var $button = $(this);
    filepicker.pick(
      {
        mimetypes: ['image/*', 'application/postscript', 'application/pdf'],
        container: 'window',
        services: ['COMPUTER', 'GOOGLE_DRIVE', 'DROPBOX']
      },
      function(blob) {
        var handle = blob.url;
        var pos = handle.lastIndexOf('/');
        if (pos >= 0) {
          handle = handle.substring(pos + 1);
        }
        if (!handle) {
          console.error('Invalid response returned from filestack picker');
          return;
        }

        var ext = blob.filename;
        pos = ext.lastIndexOf('.');
        if (pos >= 0) {
          ext = ext.substring(pos);
        }

        var $parent = $button.closest('.product-image-instruction');
        var side = $parent.hasClass('back') ? 'back' : 'front';
        var productId = $button.closest('.product-upload-images').data('product-id');
        var filename = productId + '_' + side + ext;
        $.ajax({
          method: 'GET',
          url: 'https://process.filestackapi.com/store=filename:' + filename + '/' + handle
        })
        .done(function(blobNew) {
          window.openUploadLibrary(
            {
              url: blobNew.url,
              previewUrl: window.fspUtils.cacheAndConvertFileStackUrlToJpg(blobNew.url),
              client: blob.client,
              filename: blob.filename,
              mimetype: blob.mimetype,
            },
            function(url, client) {
              // Set line item property
              $('#product-image-' + side).val(blobNew.url);
              $('#product-image-client-' + side).val(client);
              // Show image
              if (window.variableData) {
                window.vdLoadFile(url, side);
              } else {
                var $productImageContainer = $parent.siblings('.product-image.' + side);
                var $image = $productImageContainer.children('div.image');

                window.fspUtils.setImage($image, window.fspUtils.cacheAndConvertFileStackUrlToJpg(url), $productImageContainer.hasClass('landscape'));
              }
            }
          );
        })
        .error(function(error) {
          console.error(error);
          console.error('Uploaded file but failed to change name');
        });
      },
      function(FPError) {
        console.error(FPError.toString());
      }
    );
  });

  /* Select from library button */
  $('button.select-from-library').on('click', function(event) {
    if (!window.customerId) {
      //$('#login-modal').addClass('visible');
      $('#login-modal').trigger('show');
      return;
    }
    var $button = $(this);
    window.openSelectFromLibraryModal(function(url) {
      var $parent = $button.closest('.product-image-instruction');
      var side = $parent.hasClass('back') ? 'back' : 'front';
      // Set line item property
      var orgUrl = 'https://cdn.filestackcontent.com/' + url.substring(url.lastIndexOf('/') + 1);
      $('#product-image-' + side).val(orgUrl);
      $('#product-image-client-' + side).val('library');
      // Show image
      if (window.variableData) {
        window.vdLoadFile(url, side);
      } else {
        var $productImageContainer = $parent.siblings('.product-image.' + side);
        var $image = $productImageContainer.children('div.image');

        window.fspUtils.setImage($image, window.fspUtils.cacheAndConvertFileStackUrlToJpg(url), $productImageContainer.hasClass('landscape'));
      }
    });
  });

  /* Back side artwork uploader visibility */
  function checkBackSideUploaderVisibility() {
    if (window.fspUtils.getCurrentSide().substr(0, 6).toLowerCase() == 'double') {
      $('.product-image.back').removeClass('hidden');
      $('.product-image-instruction.back').removeClass('hidden');
    } else {
      $('.product-image.back').addClass('hidden');
      $('.product-image-instruction.back').addClass('hidden');
    }
  }
  var $sideSelect = window.fspUtils.getSideSelect();
  if ($sideSelect) {
    $sideSelect.on('change', checkBackSideUploaderVisibility);
  }

  /* Envelope option dependency */
  var $envelopeCheckbox = $('.product-customizer-option[data-option-name="envelopes"] input[type="checkbox"]');
  var $envelopeType = $('.product-customizer-option[data-option-name="envelopetype"] select');
  function checkEnvelopeOptionDependencies() {
    if ($envelopeCheckbox.is(':checked')) {
      $('.product-customizer-option[data-option-name="envelopestock"]').addClass('block-element');
      $('.product-customizer-option[data-option-name="envelopedescription"]').addClass('block-element');
      $('.product-customizer-option[data-option-name="envelopetype"]').addClass('block-element');
      if ($envelopeType.val() == 'Printed') {
        $('.product-customizer-option[data-option-name="envelopeprintingoptions"]').addClass('block-element');
        $('.product-customizer-option[data-option-name="frontorflap"]').addClass('block-element');
      } else {
        $('.product-customizer-option[data-option-name="envelopeprintingoptions"]').removeClass('block-element');
        $('.product-customizer-option[data-option-name="frontorflap"]').removeClass('block-element');
      }
    } else {
      $('.product-customizer-option[data-option-name="envelopetype"]').removeClass('block-element');
      $('.product-customizer-option[data-option-name="envelopestock"]').removeClass('block-element');
      $('.product-customizer-option[data-option-name="envelopeprintingoptions"]').removeClass('block-element');
      $('.product-customizer-option[data-option-name="frontorflap"]').removeClass('block-element');
      $('.product-customizer-option[data-option-name="envelopedescription"]').removeClass('block-element');
    }
  }
  $envelopeCheckbox.on('change', checkEnvelopeOptionDependencies);
  $envelopeType.on('change', checkEnvelopeOptionDependencies);

  /* Alternative Trim overlay image support for Round corners option */
  var $roundedCornersSelect = window.fspUtils.getRoundedCornersSelect();
  if (
    $roundedCornersSelect.length > 0 &&
    (!window.trimOverlayImages.base || !window.trimOverlayImages.rounded)
  ) {
    console.error('Both base and rounded version of trim overlay image should be available to provide rounded corners support');
  }
  $roundedCornersSelect.on('change', function() {
    if (!window.trimOverlayImages.base || !window.trimOverlayImages.rounded) {
      return;
    }

    if ($(this).val().toLowerCase() == 'yes') {
      $('img.trim').attr('src', window.trimOverlayImages.rounded);
    } else {
      $('img.trim').attr('src', window.trimOverlayImages.base);
    }
  });

  /* Validation on form submit */
  window.noticeTexts = {
    uploadArtWorkNotice: 'You must upload artwork for front (and back if double sided.)',
    envelopePrintingOptionsNotice: 'Please choose an envelope printing option.',
  };

  function addNoticeText(noticeText, noticeToAdd) {
    if (noticeText.length > 0) {
      noticeText += '<br />';
    }
    noticeText += '&#x25cf; ' + noticeToAdd;
    return noticeText;
  }


  /******************************************/
  /* fix product customizer */
  /* Could add blank customization options */
  /* This would skew total saved in cart */
//   var _addOptionPricingItemToCart = window.shopstorm.apps.productCustomizer.addOptionPricingItemToCart,
//       _addOptionPricingItemToCartLastArguments = [];
//   window.shopstorm.apps.productCustomizer.addOptionPricingItemToCart = function(){
//       _addOptionPricingItemToCartLastArguments = arguments;
//   // 	console.log('set args', arguments, _addOptionPricingItemToCart);
//   }
  /*******************************/
  /* end fix product customizer */
  /*****************************/

  window.onCartFormSubmit = function(event){
    var validated = true;
    var noticeText = '';
    if (
      $('input[name="properties[Envelopes]"]').is(':checked')
      && $('select[name="properties[EnvelopeType]"]').val() == 'Printed'
      && !$('#AddToCartForm input[name="properties[EnvelopePrintingOptions]"]:checked').val()
    ) {
      validated = false;
      noticeText = addNoticeText(noticeText, noticeTexts.envelopePrintingOptionsNotice);
    }
    if (
      !$('#product-image-front').val()
      || (
        !$('#product-image-back').val() &&
        window.fspUtils.getCurrentSide().substr(0, 6).toLowerCase() == 'double'
      )
    ) {
      validated = false;
      noticeText = addNoticeText(noticeText, noticeTexts.uploadArtWorkNotice);
    }
    if (!validated) {
      event.preventDefault();
      event.stopPropagation();

      if (noticeTexts.envelopePrintingOptionsNotice){
//         What's the right response? can't replicate
        window.scrollTo(0, 0);
      }

      if (noticeTexts.uploadArtWorkNotice){
        var $uploadArtworkButtons = $('.btn--secondary.upload-artwork, .btn--secondary.select-from-library'),
            $container = $('.product-image-instruction')

        $uploadArtworkButtons.addClass('warning').focus();
        $uploadArtworkButtons.before('<p class="notice-text">' + noticeText + '</p>')
        $('html, body').animate({
          scrollTop: $('.btn--secondary.upload-artwork').offset().top - 100
        }, 2000);
      }

      $('.notice').html(noticeText).removeClass('hidden');
    }

     else {
      return window.shopstorm.apps.productCustomizer.addOptionPricingItemToCart(meta.product.id);

       // fix product customizer
       // _addOptionPricingItemToCart.apply(this, _addOptionPricingItemToCartLastArguments);
       // end fix product customizer
     }


    return validated;
  }

  $('.btn--secondary.upload-artwork, .btn--secondary.select-from-library').on('click', function(){
    var $this = $(this);

    if ($this.hasClass('warning')){

      $('.btn--secondary.upload-artwork, .btn--secondary.select-from-library').removeClass('warning');
      $('.notice-text').remove();
    }
  })

  /*
   * Update button when editing cart item
   *
   * This button removes previous cart item and place new order with updated parameters
   */
  $('#UpdateCartItem').on('click', function(event) {

    // Check line parameter
    var line = window.getQueryParam('line');
    if (line < 1) {
      console.error('Invalid line parameter');
      return;
    }

    // Form validation
    if (!window.onCartFormSubmit(event)) {
      return;
    }

    var $btn = $(this);
    $btn.attr('disabled', true);

    // Now set old order quantity to 0
    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      data: {
        line: line,
        quantity: 0,
      },
      dataType: 'json',
    })
    .done(function(data) {
      var customized = window.getQueryParam('customized');
      if (customized == 'yes') {
        // Set old order customization product quantity to 0 (remove product-customizer app hidden orders)
        $.ajax({
          method: 'POST',
          url: '/cart/change.js',
          data: {
            line: line,
            quantity: 0,
          },
          dataType: 'json',
        })
        .done(function(data) {
          $('#AddToCartForm').submit();
        })
        .always(function() {
          $btn.attr('disabled', false);
        });
      }
      else {
        $('#AddToCartForm').submit();
      }
    })
    .always(function() {
      $btn.attr('disabled', false);
    });

  });

  /* Window onload event */
  $(window).load(function() {

    // Load values from URL params if existing
    if (window.getQueryParam('updatecart')) {

      // Properties
      var paramKeys = ['Paper Stock', 'Orientation', 'Sides', 'Rounded Corners', 'Description', 'Envelopes', 'EnvelopeType', 'EnvelopeStock', 'EnvelopePrintingOptions', 'FrontOrFlap', 'EnvelopeDescription', 'front_image', 'front_image_client', 'back_image', 'back_image_client'];
      var $elem = null;
      paramKeys.forEach(function(paramKey) {
        var paramVal = window.getQueryParam(paramKey);
        $elem = $('[name="properties[' + paramKey + ']"]');
        if ($elem.attr('type') == 'radio') {
          $elem = $('[name="properties[' + paramKey + ']"][value="' + paramVal + '"]');
          $elem.prop('checked', true);
        } else if (paramVal) {
          if ($elem.attr('type') == 'checkbox') {
            $elem.prop('checked', true);
          } else {
            $elem.val(paramVal);
          }
        }
      });

      // Quantity
      var qty = window.getQueryParam('quantity');
      if (qty > 0) {
        $('#Quantity').val(qty);
      }

      // Set images
      var frontImage = window.getQueryParam('front_image');
      if (frontImage) {
        var $img = $('.product-image.front .image');
        window.fspUtils.setImage($img, window.fspUtils.cacheAndConvertFileStackUrlToJpg(frontImage));
        $img.removeClass('hidden');
      }
      var backImage = window.getQueryParam('back_image');
      if (backImage) {
        var $img = $('.product-image.back .image');
        window.fspUtils.setImage($img, window.fspUtils.cacheAndConvertFileStackUrlToJpg(backImage));
        $img.removeClass('hidden');
      }

      // Trigger change event so that product customizer js recalculates price
      $($('.product-customizer-option')[0]).find('select, input').trigger('change');
    }

    // Initial state
    checkEnvelopeOptionDependencies();
    checkBackSideUploaderVisibility();

  });

  $('#UploadImages').click();

})(jQuery, window);
